import { useCallback, useState } from "react";

export const NO_SUBCIRCLES_FILTER = "__none__";

export type UserContactFilter = "all" | "mobile" | "email";
export type AliasFilter = "all" | "with" | "without";

export function useUserListFilterState() {
  const [searchQuery, setSearchQuery] = useState("");
  const [activeFilter, setActiveFilter] = useState<UserContactFilter>("all");
  const [selectedSubcircleId, setSelectedSubcircleId] = useState("");
  const [aliasFilter, setAliasFilter] = useState<AliasFilter>("all");
  const [subcircleMenuAnchor, setSubcircleMenuAnchor] =
    useState<null | HTMLElement>(null);
  const [aliasFilterMenuAnchor, setAliasFilterMenuAnchor] =
    useState<null | HTMLElement>(null);

  const isNoSubcirclesFilter = selectedSubcircleId === NO_SUBCIRCLES_FILTER;
  const activeSubcircleId =
    selectedSubcircleId && !isNoSubcirclesFilter ? selectedSubcircleId : "";

  const hasUserListFilters =
    searchQuery.trim() !== "" ||
    activeFilter !== "all" ||
    selectedSubcircleId !== "" ||
    aliasFilter !== "all";

  const handleFilterClick = useCallback((filter: UserContactFilter) => {
    setActiveFilter(filter);
  }, []);

  const handleSubcircleSelect = useCallback((subcircleId: string) => {
    setSelectedSubcircleId(subcircleId);
    setSubcircleMenuAnchor(null);
    if (!subcircleId) {
      setAliasFilter("all");
    }
  }, []);

  const handleClearUserFilters = useCallback(() => {
    setSearchQuery("");
    setActiveFilter("all");
    setSelectedSubcircleId("");
    setAliasFilter("all");
  }, []);

  return {
    searchQuery,
    setSearchQuery,
    activeFilter,
    selectedSubcircleId,
    aliasFilter,
    setAliasFilter,
    subcircleMenuAnchor,
    setSubcircleMenuAnchor,
    aliasFilterMenuAnchor,
    setAliasFilterMenuAnchor,
    isNoSubcirclesFilter,
    activeSubcircleId,
    hasUserListFilters,
    handleFilterClick,
    handleSubcircleSelect,
    handleClearUserFilters,
  };
}
